import React from "react";
import { connect } from "react-redux";
import { Translate, I18n } from "react-redux-i18n";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaComments,
  FaWhatsapp,
  FaCheck,
} from "react-icons/fa";
import PanelLayout from "../components/PanelLayout";
import PanelAdsHeader from "../components/PanelAdsHeader";
import { ListSkeleton } from "../components/Skeleton";
import * as actions from "../redux/actions/sellerContactActions";
import "./styles/PanelContact.css";
import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";

class PanelContact extends React.Component {
  state = {
    email: false,
    phone: false,
    chat: false,
    whatsapp: false,
    emailAddress: "",
    phoneNumber: "",
    ready: false,
  };

  async componentDidMount() {
    const { user_id, token } = this.props;
    if (!user_id || !token) return;

    const result = await this.props.LoadContact(user_id, token);
    if (result && result.ok) {
      this.setState({
        email: Boolean(result.data.Email),
        phone: Boolean(result.data.Phone),
        chat: Boolean(result.data.Chat),
        whatsapp: Boolean(result.data.Whatsapp),
        emailAddress: result.data.EmailAddress || "",
        phoneNumber: result.data.PhoneNumber || "",
        ready: true,
      });
    } else {
      this.setState({ ready: true });
      alertify.warning(I18n.t((result && result.error) || "try_later"));
    }
  }

  toggle = (field) => () => {
    const next = !this.state[field];
    const patch = { [field]: next };

    if (field === "phone" && !next) {
      patch.whatsapp = false;
    }

    this.setState(patch);
  };

  onSave = async () => {
    const { user_id, token } = this.props;
    const { email, phone, chat, whatsapp } = this.state;

    const result = await this.props.UpdateContact(
      user_id,
      token,
      email,
      phone,
      chat,
      phone ? whatsapp : false
    );

    if (result && result.ok) {
      alertify.success(I18n.t("contact_saved"));
    } else {
      alertify.warning(I18n.t((result && result.error) || "try_later"));
    }
  };

  renderMethodLabel() {
    const { email, phone, chat } = this.state;
    const methods = [];

    if (email) methods.push(I18n.t("contact_method_email"));
    if (phone) methods.push(I18n.t("contact_method_phone"));
    if (chat) methods.push(I18n.t("contact_method_chat"));

    if (!methods.length) return I18n.t("contact_method_none");
    return methods.join(", ");
  }

  render() {
    if (!this.state.ready || this.props.loading) {
      return (
        <PanelLayout>
          <ListSkeleton />
        </PanelLayout>
      );
    }

    const { email, phone, chat, whatsapp, emailAddress, phoneNumber } =
      this.state;

    return (
      <PanelLayout>
        <div className="panel-contact-page">
          <PanelAdsHeader
            title={<Translate value="contact_panel_title" />}
            subtitle={<Translate value="contact_panel_subtitle" />}
          />

          <div className="contact-options">
            <button
              type="button"
              className={
                "contact-option" + (email ? " contact-option--active" : "")
              }
              onClick={this.toggle("email")}
            >
              <span className="contact-option__icon">
                <FaEnvelope />
              </span>
              <span className="contact-option__body">
                <span className="contact-option__name">
                  <Translate value="contact_method_email" />
                </span>
                <span className="contact-option__desc">
                  {emailAddress ? (
                    <span className="contact-option__value">{emailAddress}</span>
                  ) : (
                    <Translate value="contact_email_desc" />
                  )}
                </span>
              </span>
              <span
                className={
                  "contact-option__check" +
                  (email ? " contact-option__check--on" : "")
                }
              >
                {email && <FaCheck />}
              </span>
            </button>

            <button
              type="button"
              className={
                "contact-option" + (phone ? " contact-option--active" : "")
              }
              onClick={this.toggle("phone")}
            >
              <span className="contact-option__icon">
                <FaPhoneAlt />
              </span>
              <span className="contact-option__body">
                <span className="contact-option__name">
                  <Translate value="contact_method_phone" />
                </span>
                <span className="contact-option__desc">
                  {phoneNumber ? (
                    <span className="contact-option__value">{phoneNumber}</span>
                  ) : (
                    <Translate value="contact_phone_desc" />
                  )}
                </span>
              </span>
              <span
                className={
                  "contact-option__check" +
                  (phone ? " contact-option__check--on" : "")
                }
              >
                {phone && <FaCheck />}
              </span>
            </button>

            <button
              type="button"
              className={
                "contact-option" + (chat ? " contact-option--active" : "")
              }
              onClick={this.toggle("chat")}
            >
              <span className="contact-option__icon">
                <FaComments />
              </span>
              <span className="contact-option__body">
                <span className="contact-option__name">
                  <Translate value="contact_method_chat" />
                </span>
                <span className="contact-option__desc">
                  <Translate value="contact_chat_desc" />
                </span>
              </span>
              <span
                className={
                  "contact-option__check" +
                  (chat ? " contact-option__check--on" : "")
                }
              >
                {chat && <FaCheck />}
              </span>
            </button>
          </div>

          {phone && (
            <div className="contact-whatsapp">
              <button
                type="button"
                className={
                  "contact-whatsapp__toggle" +
                  (whatsapp ? " contact-whatsapp__toggle--active" : "")
                }
                onClick={this.toggle("whatsapp")}
              >
                <span className="contact-whatsapp__icon">
                  <FaWhatsapp />
                </span>
                <span className="contact-whatsapp__body">
                  <span className="contact-whatsapp__name">
                    <Translate value="contact_whatsapp" />
                  </span>
                  <span className="contact-whatsapp__desc">
                    <Translate value="contact_whatsapp_desc" />
                  </span>
                </span>
                <span
                  className={
                    "contact-option__check" +
                    (whatsapp ? " contact-option__check--on" : "")
                  }
                >
                  {whatsapp && <FaCheck />}
                </span>
              </button>
            </div>
          )}

          <div className="contact-summary">
            <span className="contact-summary__label">
              <Translate value="contact_selected" />
            </span>
            <span className="contact-summary__value">
              {this.renderMethodLabel()}
            </span>
          </div>

          <button
            type="button"
            className="contact-save-btn"
            onClick={this.onSave}
            disabled={this.props.saving}
          >
            {this.props.saving ? "..." : I18n.t("save")}
          </button>
        </div>
      </PanelLayout>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    loading: reducer.sellerContact.loading,
    saving: reducer.sellerContact.saving,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadContact: (user_id, token) =>
    dispatch(actions.loadItem({ user_id, token })),
  UpdateContact: (user_id, token, email, phone, chat, whatsapp) =>
    dispatch(
      actions.updateItem({ user_id, token, email, phone, chat, whatsapp })
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(PanelContact);
